export class Loading {

    enabled: boolean = false;
    failed: boolean = false;

    constructor() 
        {
            this.failed = false;
            this.enabled = false;
        }

    begin(): void {
        this.enabled = true;
    }

    finish(): void {
        this.enabled = false;
    }

    isLoading(): boolean {
        return this.enabled;
    }
}